import axios from 'axios';
import EnvJS from "./env";

async function getProducts(usuario_url){

  return await axios.get(EnvJS.URL_API + 'grupos/secoes/produtos/empresa/' + usuario_url).then(res=>{
    if(res.data){
      return res;
    }
  }).catch(error=>{
    return null;
  });

}

export default{
  getProducts
}



// WEBPACK FOOTER //
// ./src/api/ProductApi.js